import { cx } from "@emotion/css";
import type React from "react";

import SimpleProgressBar from "../Default/LekUI/SimpleProgressBar";

interface ProgressComponentProps {
	allItems: number;
	resolvedItems: number;
	unit?: string;
	color?: "primary" | "secondary" | "error" | "info" | "success" | "warning" | "inherit";
	className?: string;
	disablePercent?: boolean;
	renderText?: () => React.ReactNode;
}

function ProgressComponent(props: ProgressComponentProps) {
	const { allItems, resolvedItems } = props;
	const value = Math.round((resolvedItems / allItems) * 100);

	const renderText = () => {
		if (props.renderText) {
			return props.renderText();
		}

		return (
			<div className="flex items-center justify-between greyText size-12 mb-8">
				<span data-test-id="exam-progress-text">{`${resolvedItems} / ${allItems} ${props.unit}`}</span>
				<span>{Math.round((resolvedItems * 100) / allItems)}%</span>
			</div>
		);
	};

	return (
		<div className={cx(props.className, "w-100")}>
			{renderText()}
			<SimpleProgressBar
				color={props.color || "primary"}
				variant="determinate"
				value={value}
			/>
		</div>
	);
}

export default ProgressComponent;
